import PropTypes from 'prop-types'
import { useState } from 'react'

import { FormModal, Snackbar } from '../../default'
import { CreatePlanForm } from '../../forms'

/**
 * @description CreatePlanModal function displays a modal for creating a new plan.
 *
 * @author Maria Eduarda Franke
 * @param {boolean} open - Determines whether the modal is open or not.
 * @param {function} onClose - Callback function to close the modal.
 * @returns {JSX.Element} - The rendered JSX element.
 */
const CreatePlanModal = ({ open, onClose }) => {

    const [showSnackbar, setShowSnackbar] = useState(false)

    const handleSnackbarClose = (_, reason) => {
        if (reason === 'clickaway') return
        setShowSnackbar(false)
    }

    return (
        <>
            <FormModal
                title='Criar Plano'
                open={open} onClose={onClose}
            >
                <CreatePlanForm onClose={onClose} setShowSnackbar={setShowSnackbar} />
            </FormModal>
            <Snackbar
                open={showSnackbar}
                onClose={handleSnackbarClose}
                vertical='bottom'
                horizontal='right'
                severity='success'
                variant='filled'
                message='Novo plano criado com sucesso!'
                sx={{ mt: 1 }}
            />
        </>
    )

}

CreatePlanModal.propTypes = {
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired
}

export default CreatePlanModal